import { QuantitySelectorComponent } from '@theme/component-quantity-selector';
import { QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Minus is only disabled when the line cannot be updated (server-disabled)
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Minus stays enabled at the minimum, where it removes the line instead
    minusButton.disabled = this.serverDisabledMinus;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * Decreases the quantity, or removes the line when already at the minimum.
   * @param {Event} event - The event.
   */
  decreaseQuantity(event) {
    const { min, step, value } = this.getCurrentValues();
    if (value - step >= min) return super.decreaseQuantity(event);

    event.preventDefault();
    const { quantityInput } = this.refs;
    this.dispatchEvent(new QuantitySelectorUpdateEvent(0, Number(quantityInput.dataset.cartLine) || undefined));
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
